import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  px: 2,
  background: "linear-gradient(135deg, #f8fafc, #f1f5f9)",
}));

export const HeaderLogoImage = styled("img")(() => ({
  width: 200,
  height: "auto",
}));

export const StyledLogoContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginBottom: "2rem",
}));
